module.exports = __webpack_public_path__ + "static/media/TA-Square-Logo.716e9da3.png";